import request from '@/router/axios'

/**
 * 鳄币商城列表
 * @param {*} data 
 * @returns 
 */
export function foodmacOrderv2ShopGoodsManagePage (data) {
  return request({
    url: `/foodmac_orderv2/shop/goods/manage/page`,
    method: 'post',
    data
  })
}

/**
 * 上架/下架商品
 * @param {*} data 
 * @returns 
 */
export function foodmacOrderv2ShopGoodsManageUpdatestatus (data) {
    return request({
      url: `/foodmac_orderv2/shop/goods/manage/updateStatus`,
      method: 'post',
      data
    })
}

/**
 * 提交排序结果
 * @param {*} data 
 * @returns 
 */
export function foodmacOrderv2ShopGoodsManageUpdatesort (data) {
    return request({
      url: `/foodmac_orderv2/shop/goods/manage/updateSort`,
      method: 'post',
      data
    })
}

/**
 * 鳄币 - 详情页提交（新建/编辑）
 * @param {*} data 
 * @returns 
 */
export function foodmacOrderv2ShopGoodsManageSave (data) {
    return request({
      url: `/foodmac_orderv2/shop/goods/manage/save`,
      method: 'post',
      data
    })
}

/**
 * 鳄币 - 根据id回显详情
 * @param {*} data 
 * @returns 
 */
export function foodmacOrderv2ShopGoodsManageDetail (data) {
    return request({
      url: `/foodmac_orderv2/shop/goods/manage/detail`,
      method: 'post',
      data
    })
}